import { render, staticRenderFns } from "./DevCardKD6.vue?vue&type=template&id=3c8ae668&scoped=true"
import script from "./DevCardKD6.vue?vue&type=script&lang=js"
export * from "./DevCardKD6.vue?vue&type=script&lang=js"
import style0 from "./DevCardKD6.vue?vue&type=style&index=0&id=3c8ae668&prod&lang=css"
import style1 from "./DevCardKD6.vue?vue&type=style&index=1&id=3c8ae668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8ae668",
  null
  
)

export default component.exports